import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Self-hosted: an internal tool should not make a request to a third party to
// render its own text, and the sans/mono split is load-bearing enough that a
// swap would be visible.
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import './lib/tokens.css'
import { App } from './app/App'
import { AuthProvider } from './app/AuthProvider'
import { ThemeProvider } from './app/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The views poll. Refetching on focus as well means someone coming back
      // from a meeting sees current state without waiting for the next tick.
      refetchOnWindowFocus: true,
      staleTime: 5_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
